var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.4C11.5346 14.4 14.4 11.5346 14.4 7.99998C14.4 4.46535 11.5346 1.59998 8 1.59998C4.46538 1.59998 1.6 4.46535 1.6 7.99998C1.6 11.5346 4.46538 14.4 8 14.4ZM10.9657 6.96566C11.2781 6.65324 11.2781 6.14671 10.9657 5.83429C10.6533 5.52187 10.1467 5.52187 9.83431 5.83429L7.2 8.4686L6.16568 7.43429C5.85326 7.12187 5.34673 7.12187 5.03431 7.43429C4.72189 7.74671 4.72189 8.25324 5.03431 8.56566L6.63431 10.1657C6.94673 10.4781 7.45326 10.4781 7.76568 10.1657L10.9657 6.96566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIconWhite);
export default __webpack_public_path__ + "static/media/verified-icon-white.1476313d0777a41983a11e4f5a5190a2.svg";
export { ForwardRef as ReactComponent };